import * as React from "react";
import { Helpers } from "../../utils/helpers";
import { AnalyticsConstants } from "./pages/constants";

export class Analytics extends React.Component<any, any> {

    constructor(props) {
        super(props);

        this.state = {
            page: this.props.match.params.page,
        };

        document.title = Helpers.documentTitle("Analytics");
    }

    render() {
        switch (this.state.page) {
            case "constants":
                return <div className="contentPadding"><AnalyticsConstants/></div>
            default:
                return <div className="contentPadding">Page not found</div>
        }
    }
}
